import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceRunFileUrlQueryVariables = Types.Exact<{
  key: Types.Scalars['String'];
}>;


export type InvoiceRunFileUrlQuery = { __typename?: 'Query', invoiceRunFileUrl: string };


export const InvoiceRunFileUrlDocument = gql`
    query InvoiceRunFileUrl($key: String!) {
  invoiceRunFileUrl(key: $key)
}
    `;

/**
 * __useInvoiceRunFileUrlQuery__
 *
 * To run a query within a React component, call `useInvoiceRunFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRunFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceRunFileUrlQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useInvoiceRunFileUrlQuery(baseOptions: Apollo.QueryHookOptions<InvoiceRunFileUrlQuery, InvoiceRunFileUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceRunFileUrlQuery, InvoiceRunFileUrlQueryVariables>(InvoiceRunFileUrlDocument, options);
      }
export function useInvoiceRunFileUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceRunFileUrlQuery, InvoiceRunFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceRunFileUrlQuery, InvoiceRunFileUrlQueryVariables>(InvoiceRunFileUrlDocument, options);
        }
export type InvoiceRunFileUrlQueryHookResult = ReturnType<typeof useInvoiceRunFileUrlQuery>;
export type InvoiceRunFileUrlLazyQueryHookResult = ReturnType<typeof useInvoiceRunFileUrlLazyQuery>;
export type InvoiceRunFileUrlQueryResult = Apollo.QueryResult<InvoiceRunFileUrlQuery, InvoiceRunFileUrlQueryVariables>;